import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Kebabs = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    {...props}
  >
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </svg>
);
Kebabs.propTypes = { fill: PropTypes.string };
Kebabs.defaultProps = { fill: iconColorsMap.mainicon };

export default Kebabs;
